export const sideBarLabels = {
  TENANT: {
    topTitle: "企業新規登録",
    companySettings: "基本情報設定",
    viewCompanies: "企業一覧",
    createCompany: "企業新規登録",
  },
  KAKELY: {
    topTitle: "KAKELY管理",
    departmentView: "部署一覧",
    externalPhonebookView: "社外電話帳",
    viewAllPhonebooks: "社外電話帳一覧",
    csvUploadExternal: "社外電話帳一括登録",
    csvUploadInternal: "社内電話帳一括登録",
  },
  YOBELY: {
    topTitle: "YOBELY管理",
    viewGroups: "一斉発信グループ一覧",
  },
  USER: {
    topTitle: "社内電話帳管理",
    internalPhonebookView: "社内電話帳",
    view: "社内電話帳一覧",
    create: "社内電話帳新規登録",
    csvUpload: "社内電話帳一括登録",
    personalTopTile: "管理者メニュー",
    myPage: "管理者情報参照・編集",
    passwordChange: "管理者パスワード変更",
  },
  NOTIFICATION: {
    topTitle: "お知らせ管理",
    view: "お知らせ一覧",
    create: "お知らせ追加",
  },
  WORKJOY: {
    topTitle: "WORKJOY管理",
    hub: "メインページ",
    manageMentalCare: "メンタルヘルスケア管理",
    manageSettings: "スタンプ管理",
    biToolSettings: "BIツール",
  },
  GENERIC: {
    infoTopTitle: "INFO",
  },
};
